const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGardlistLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "424pt",
    height: "600pt",
    viewBox: "-400 -400 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.901961%,34.509804%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 125.507812 484.191406 L 125.507812 406.949219 L 13.84375 406.949219 L 141.203125 0.5625 L 195.78125 191.53125 C 180.878906 212.414062 172.125 237.992188 172.125 265.621094 C 172.125 318.648438 204.507812 364.191406 250.710938 383.714844 L 257.394531 406.949219 L 146.984375 406.949219 L 146.984375 484.191406 L 125.507812 484.191406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,75.686275%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 193 265.621094 C 193 206.203125 241.398438 158.175781 301.070312 158.175781 C 360.738281 158.175781 409.121094 206.203125 409.121094 265.621094 C 409.121094 321.148438 366.695312 366.894531 312.265625 372.476562 L 312.265625 487.160156 L 289.839844 487.160156 L 289.839844 372.476562 C 235.46875 366.894531 193 321.148438 193 265.621094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588235%,90.196078%,90.980392%)",
      fillOpacity: 1
    },
    d: "M 136.144531 599.34375 L 15.226562 506.101562 L 125.945312 506.101562 L 126.082031 490.039062 L 147.265625 490.039062 L 147.265625 506.101562 L 256.785156 506.101562 L 250.175781 511.25 C 204.078125 515.585938 171.375 525.742188 170.835938 537.847656 C 170.574219 544.042969 179.054688 549.832031 194.011719 554.707031 L 136.144531 599.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588235%,90.196078%,90.980392%)",
      fillOpacity: 1
    },
    d: "M 301.683594 568.265625 C 241.160156 568.265625 192.558594 557.207031 193.089844 543.648438 C 193.617188 531.136719 236.261719 520.863281 290.292969 519.539062 L 290.292969 494.265625 L 312.410156 494.265625 L 312.679688 519.539062 C 366.847656 520.863281 409.625 531.136719 410.144531 543.648438 C 410.675781 557.207031 362.207031 568.265625 301.683594 568.265625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardlistLogo);
export default __webpack_public_path__ + "static/media/gardlist-logo.cf82a8d21189e017716ec4c132a3313b.svg";
export { ForwardRef as ReactComponent };